enum SlotValueType {
  ENUMERATED_VALUE = 'ENUMERATED_VALUE',
  NUMBER = 'NUMBER',
  FREE_TEXT = 'FREE_TEXT',
  DATE = 'DATE',
  DOCUMENT_UPLOAD = 'DOCUMENT_UPLOAD',
  EMAIL = 'EMAIL',
  BOOLEAN = 'BOOLEAN'
}

export const SlotValueTypeLabels: Record<SlotValueType, string> = {
  [SlotValueType.ENUMERATED_VALUE]: 'Enumerated value',
  [SlotValueType.NUMBER]: 'Number',
  [SlotValueType.FREE_TEXT]: 'Free text',
  [SlotValueType.DATE]: 'Date',
  [SlotValueType.DOCUMENT_UPLOAD]: 'Document upload',
  [SlotValueType.EMAIL]: 'Email',
  [SlotValueType.BOOLEAN]: 'Boolean'
};

export default SlotValueType;
